import React from 'react';
import { connect } from 'react-redux';
import { t } from 'i18next';
import AreaChart from '../../reports/areaChartReport/AreaChartReport';
import BarChart from '../../reports/barChartReport/BarChartReport';
import DataSnapshot from '../../aylaTimeZone/AylaTimeZone';
import FilterPanel, {
  date_range, dsn, notification_type, oem_id, oem_model,
} from '../../filters/filterPanel/FilterPanel';
import LineChart from '../../reports/lineChartReport/LineChartReport';
import MapLayout from '../../reports/mapReport/MapReport';
import ReportPage from '../ReportPage';
import TimeAggregation from '../../filters/timeAggregationFilter/TimeAggregationFilter';
import TitleBar from '../../titleBar/TitleBar';
import {AYLA_ALLOWED_ROLES, GoogleAnalyticsConstants} from '../../../constants';
import {
  activatedDevices, datapointCountByValueOverTime,
  deviceAlertsSentByTime, deviceDailyTransactionTrend,
  deviceLocation, deviceTransactionsCreatedByTime,
  listOfNotificationTypes, listOfOemModels,
  listOfOems, totalDatapoints, devicesOnlineToday, contractTotalDatapointsTransactions
} from '../../../services/reportsservice';
import './DeviceDetailsPage.css';
import {logPageViewEvent} from "../../../services/analyticsservice";
import {getErrorReportNames, getReportData} from "../../../helpers/utils";

class DeviceDetailsPage extends ReportPage {
  googleAnalytics() {
    const { logged_in_oem_id } = this.props.presistFilters;
    logPageViewEvent(GoogleAnalyticsConstants.DeviceDetailsPage.title, logged_in_oem_id);
  }
  reports() {
    const filters = this.props.presistFilters;
    const isUsFieldDpMeteringOem = (this.props.presistFilters.region_name === 'US-FIELD'
      && this.us_field_dp_metering_oems.includes(this.props.presistFilters.oem_id));
    const isEuFieldDpMeteringOem = (this.props.presistFilters.region_name === 'EU'
        && this.eu_field_dp_metering_oems.includes(this.props.presistFilters.oem_id));
    const isSharkVpc = (((this.props.presistFilters.region_name === 'US-VPC') || (this.props.presistFilters.region_name === 'EU'))
        && this.props.presistFilters.oem_id === '39a9391a');

    return filters.dsn ? {
      filters: [
        listOfOemModels(filters),
        listOfNotificationTypes(filters),
        listOfOems(filters)],

      reports: [
        activatedDevices(filters),
        totalDatapoints(filters),
        devicesOnlineToday(filters),
        datapointCountByValueOverTime(filters),
        deviceAlertsSentByTime(filters),
        deviceTransactionsCreatedByTime(filters),
        deviceDailyTransactionTrend(filters),
        deviceLocation(filters),
      ],
    } : {
      filters: [
        listOfOemModels(filters),
        listOfNotificationTypes(filters),
        listOfOems(filters),
      ],
      reports: (isUsFieldDpMeteringOem || isEuFieldDpMeteringOem || isSharkVpc) ? [
            activatedDevices(filters),
            contractTotalDatapointsTransactions(filters),
            devicesOnlineToday(filters),
          ]
          : [
        activatedDevices(filters),
        totalDatapoints(filters),
        devicesOnlineToday(filters),
      ],
    };
  }

  reportsDescription = () => [
    datapointCountByValueOverTime(),
    deviceAlertsSentByTime(),
    deviceDailyTransactionTrend(),
    deviceTransactionsCreatedByTime(),
  ];

  render() {
    const {
      errors, session, presistFilters, sidebarVisible,
    } = this.props;
    if(errors.length > 0) getErrorReportNames(errors);
    const isRequired = (data) => {
      if (! presistFilters.dsn || ! data) { return true; }
      return false;
    };

    const defaultPopUp = () => {
      if (presistFilters.dsn || sidebarVisible) { return true; }
      return false;
    };


    return (
      <div className="DeviceDetailsPage page">
        <TitleBar title="deviceDetails">
          <TimeAggregation value={this.props.presistFilters.aggregate_by} />
          <DataSnapshot snapShot={this.dataSnapshotTime} />
        </TitleBar>
        <div className="pageContent">
          <FilterPanel currentFilters={this.props.presistFilters}
            filters={[
              date_range,
              AYLA_ALLOWED_ROLES.includes(session.role)
              && oem_id(this.report(listOfOems)),
              oem_model(this.report(listOfOemModels)),
              notification_type(this.report(listOfNotificationTypes)),
              dsn(true),
            ]}
            defaultOpenModal={defaultPopUp() ? undefined : dsn(true)}
          />


          <div>
            <LineChart title={t('devices.connectivityTitle')}
              width={this.widthForColumns(2)}
              height={200}
              data={getReportData(this.report(datapointCountByValueOverTime), 'Device_Connectivity_Events_By_Time')}
              description={this.reportDescription(datapointCountByValueOverTime)}
              xLabel={this.props.presistFilters.aggregate_by}
              yLabel="events"
              inputRequired={isRequired(this.report(datapointCountByValueOverTime))}
              helperMsg={t('devices.dsnHelperMsg')}
              skipDetailsTranslation
            />
            <BarChart title={t('devices.notificationsTitle')}
              width={this.widthForColumns(2)}
              height={200}
              data={getReportData(this.report(deviceAlertsSentByTime), 'Notifications_Sent_Over_Time')}
              description={this.reportDescription(deviceAlertsSentByTime)}
              xLabel={this.props.presistFilters.aggregate_by}
              yLabel="notifications"
              inputRequired={isRequired(this.report(deviceAlertsSentByTime))}
              helperMsg={t('devices.dsnHelperMsg')}
            />
          </div>

          <div>
            <AreaChart title={t('devices.transmissionTitle')}
              width={this.widthForColumns(2)}
              height={200}
              data={getReportData(this.report(deviceTransactionsCreatedByTime), 'Device_Transactions_Created_Over_Time')}
              description={this.reportDescription(deviceTransactionsCreatedByTime)}
              xLabel={this.props.presistFilters.aggregate_by}
              yLabel="transmissions"
              inputRequired={isRequired(this.report(deviceTransactionsCreatedByTime))}
              helperMsg={t('devices.dsnHelperMsg')}
              skipDetailsTranslation
              grouped
            />
            <BarChart title={t('devices.transmissionTrendTitle')}
              width={this.widthForColumns(2)}
              height={200}
              data={getReportData(this.report(deviceDailyTransactionTrend), 'Daily_Transaction_Trend_Over_Time')}
              description={this.reportDescription(deviceDailyTransactionTrend)}
              xLabel={this.props.presistFilters.aggregate_by}
              yLabel="devices"
              inputRequired={isRequired(this.report(deviceDailyTransactionTrend))}
              helperMsg={t('devices.dsnHelperMsg')}
              skipDetailsTranslation
            />
          </div>
          <div>
            <MapLayout title="devices.location"
              width={this.widthForColumns(1)}
              height={600}
              markers={this.report(deviceLocation)}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => state)(DeviceDetailsPage);
